<template>
  <div class="navbar"
    :style="backgroundImageAndlogo.headerBgColor ? { background: backgroundImageAndlogo.headerBgColor, color: backgroundImageAndlogo.headerColor ? backgroundImageAndlogo.headerColor : '#ffffff' } : ''">
    <div class="navbar-inner">
      <logo v-if="showLogo" :collapse="isCollapse" />
      <div class="left-menu">
        <div class="router-list">
          <router-link v-for="(router, index) of visibleMenu" :key="index" class="menu-item"
            :style="backgroundImageAndlogo.headerColor ? { color: backgroundImageAndlogo.headerColor } : ''"
            :to="router.path">{{
              $t(router.meta.titleKey || router.meta.title) }}
                <span v-if="router.path === '/ai'" class="ai-beta-badge">{{ $t('aiUsageSync.beta') }}</span>
          </router-link>
          <!-- 更多菜单 -->
          <div v-if="hiddenMenu.length > 0" class="dropdown">
            <div class="menu-item more-menu" style="font-size: 16px; font-weight: 900;"
              :style="backgroundImageAndlogo.headerColor ? { color: backgroundImageAndlogo.headerColor } : ''">{{
                $t('common.more') }}</div>
            <div
              :style="backgroundImageAndlogo.headerBgColor ? { background: backgroundImageAndlogo.headerBgColor, color: backgroundImageAndlogo.headerColor ? backgroundImageAndlogo.headerColor : '#ffffff', border: '0px' } : ''"
              class="dropdown-content">
              <router-link v-for="(router, index) in hiddenMenu" :key="'hidden-' + index" class="menu-item"
                :style="backgroundImageAndlogo.headerColor ? { color: backgroundImageAndlogo.headerColor } : ''"
                :to="router.path">
                {{ $t(router.meta.titleKey || router.meta.title) }}
                <span v-if="router.path === '/ai'" class="ai-beta-badge">{{ $t('aiUsageSync.beta') }}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="right-menu">
        <el-popover v-model="toggleHotel" placement="bottom-start" width="428" trigger="click"
          popper-class="hotel-popver">
          <div class="hotel-search-wrapper">
            <el-input v-model="keywords" v-reg-input:blank :placeholder="$t('navbar.searchHotel')" class="remote-input">
              <i slot="prefix" class="el-input__icon el-icon-search" />
            </el-input>
            <div v-loading="hotelListLoading" class="remote-list-wrapper"
              :element-loading-text="$t('common.loadingEllipsis')" element-loading-spinner="el-icon-loading">
              <div v-for="(hotel, hotelIndex) of hotelListData" :key="hotelIndex" class="hotel-item-wrapepr"
                @click="changeHotel(hotel.hotelCode, hotel.hotelName)">
                {{ hotel.hotelName }} - {{ hotel.hotelCode }}
              </div>
              <div v-if="!hotelListLoading && !hotelListData.length" class="empty-hotel-tip">
                {{ $t('common.noResults') }}
              </div>
            </div>
            <div class="bottom-wrapper">
              <el-button class="close-btn" @click="toggleHotel = false">{{
                $t('common.close')
              }}</el-button>
            </div>
          </div>
          <div slot="reference" class="current-hotel-name">
            <span class="hotel-name-span" :class="{ 'empty-hotel': !isQzHotel }">{{
              hotelName
            }}</span>
            <i :class="toggleClass" />
          </div>
        </el-popover>
        <QzDialog :title="hotelName" :append-to-body="true" :visible.sync="show" width="420px"
          class="status-dialog-navbar-el" :noFooter="true">
          <template>
            <div class="hotel-search-wrapper-shifts">
              <h3 style="text-align: center;">{{ hotelName }}</h3>
              <div class="shifts">
                <div>{{ $t('common.currentShift') }}：{{ userShifts ? userShifts.name : '' }}</div>
                <div>{{ $t('common.salesClerk') }}：{{ name }}</div>
                <div>{{ $t('common.businessDay') }}：{{ businessDay }}</div>
                <div>
                  {{ $t('common.printTime') }} ：{{
                    new Date().toLocaleDateString().replace(/\//g, '-') +
                    ' ' +
                    new Date().toLocaleTimeString()
                  }}
                </div>
              </div>
              <el-table :data="shiftsData" stripe style="width: 100%;">
                <el-table-column prop="subjectName" :label="$t('common.subject')" width="180" height="20">
                  <template v-slot="{ row }">
                    <span v-if="row.isChild" style="margin-left: 40px;">{{ row.subjectName }}</span>
                    <span v-else>{{ row.subjectName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="total" :label="$t('common.amount')" width="180">
                </el-table-column>
              </el-table>
              <div class="shiftsData-button">
                <v-button :name="$t('common.printReport')" :left="20" size="small" @click="refPrint('printContent')"
                  type="normal-bg"></v-button>
                <v-button :name="$t('common.cancel')" :left="20" size="small" @click="
                  () => {
                    this.show = false;
                  }
                "></v-button>
                <v-button :name="$t('common.shiftHandover')" type="normal-bg" :left="20" size="small"
                  @click="logout"></v-button>
              </div>
            </div>
          </template>
        </QzDialog>
        <el-popover placement="bottom-start" width="268" trigger="click" popper-class="hotel-popver" v-model="shifts">
        </el-popover>
        <!-- <div
          slot="reference"
          class="current-hotel-name"
          @click="
            () => {
              this.show = true;
            }
          "
          style="margin-left: 20px;"
        >
          {{ $t('common.shiftHandover') }}
        </div> -->

        <!-- <div class="menu-item order shifts">
          <img v-if="avatar" :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar" alt />
          <img v-else src="@/assets/default-avatar.png" class="user-avatar" alt />
          <span class="user-name" :class="{ notQz: !isQzHotel }">{{ name }}</span>
          <span v-if="isQzHotel" class="shift-name" style="cursor: pointer;" @click="changeOrder"> -->
        <!-- 班次: -->
        <!-- <span>{{ userShifts ? userShifts.name : '' }}</span>
          </span>
        </div> -->
        <!-- 新增语言切换按钮 -->
        <!-- <el-select
          v-model="language"
          class="language-select"
          popper-class="language-select-popper"
          @change="toggleLanguage"
        >
          <el-option :label="$t('language.zh')" value="zh-CN" />
          <el-option :label="$t('language.en')" value="en-US" />
          <el-option :label="$t('language.zhHk')" value="zh-HK" />
        </el-select> -->

        <div v-if="!hideAppShopEntry" class="profile-picture" @click="jumpToTheAppStore">
          <img src="@/assets/appStore.png" class="user-avatar" alt />
        </div>
        <el-popover placement="bottom" width="100" trigger="click">
          <div>
            <div class="dropdown-style">
              <div class="dropdown-item" @click="toggleLanguage('zh-CN')">
                <div>{{ $t('language.zh') }}</div>
              </div>
              <div class="dropdown-item" @click="toggleLanguage('en-US')">
                <div>{{ $t('language.en') }}</div>
              </div>
              <div class="dropdown-item" @click="toggleLanguage('zh-HK')">
                <div>{{ $t('language.zhHk') }}</div>
              </div>
              <div class="dropdown-item" @click="toggleLanguage('th-TH')">
                <div>{{ $t('language.th') }}</div>
              </div>
              <div class="dropdown-item" @click="toggleLanguage('id-ID')">
                <div>{{ $t('language.id') }}</div>
              </div>
              <div class="dropdown-item" @click="toggleLanguage('es-ES')">
                <div>{{ $t('language.es') }}</div>
              </div>
              <div class="dropdown-item" @click="toggleLanguage('vi-VN')">
                <div>{{ $t('language.vi') }}</div>
              </div>
            </div>
          </div>

          <div class="profile-picture" slot="reference">
            <img src="@/assets/svg/en-US.svg" v-if="language === 'en-US'" class="user-avatar" alt />
            <!-- <img src="@/assets/svg/th.svg" v-if="language === 'th-TH'" class="user-avatar" alt /> -->
            <img src="@/assets/svg/zh-HK.svg" v-else-if="language === 'zh-HK'" class="user-avatar" alt />
            <!-- language.svg -->
            <img src="@/assets/svg/zh-CN.svg" v-else-if="language === 'zh-CN'" class="user-avatar" alt />
            <img src="@/assets/svg/language.svg" v-else class="user-avatar" alt />
          </div>
        </el-popover>
        <div class="profile-picture" @click="toggleNotificationDisplay">
          <img src="@/assets/messagePrompt.png" class="user-avatar" alt />
          <div class="notification-count" v-if="systemMessage != 0">{{ systemMessage }}</div>
        </div>
        <div v-if="isQzHotel" class="night-check" @click="beforeStart">
          {{ $t('navbar.nightAudit') }}
        </div>

        <!-- <div v-if="isQzHotel" class="menu-item working-day" @click="workingDayLog">
          <label style="cursor: pointer; font-weight: normal;">{{ $t('common.businessDay') }}：</label>
          <span class="menu-item-text">{{ datetimeFormat(businessDay, 'MM-DD') }}</span>
        </div> -->
        <!-- <div v-if="isHelpShow" class="menu-item help-center">
          <div class="nav-icon-wrapper help" @click="goToHelp" />
        </div>
        <div class="menu-item logout" @click="logout">
          <div class="nav-icon-wrapper exit" />
        </div> -->
        <el-popover placement="bottom" width="207" v-model="visible" trigger="click">
          <div>
            <div class="dropdown-style">
              <div class="pop-up-box-item">
                <div class="pull-down-style">
                  <img v-if="avatar" :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar" alt />
                  <img v-else src="@/assets/default-avatar.svg" class="user-avatar" alt />
                  <img :src="require(`@/assets/svg/${userShifts && userShifts.code ? userShifts.code : 'morningShift'
                    }.svg`)
                    " class="user-avatar-img" alt />
                </div>
                <div>
                  <div class="user-name-pop">{{ name }}</div>
                  <div class="profile-picture-shift-name-pop">{{ $t('common.businessDay') }}：{{
                    datetimeFormat(businessDay,
                      'MM-DD') }}</div>
                </div>
              </div>
              <div class="dropdown-item" @click="changeOrder">
                <img src="@/assets/svg/huanbanguanli1.svg" class="iconNotSelected" alt="" />
                <img src="@/assets/svg/huanbanguanli.svg" class="selectTheIcon" alt="" />
                <div>{{ $t('componentsNavbar.shiftManagement') }}</div>
              </div>
              <div class="dropdown-item" @click="show = true">
                <img src="@/assets/svg/shiftHandover.svg" class="iconNotSelected" alt="" />
                <img src="@/assets/svg/shiftHandover1.svg" class="selectTheIcon" alt="" />
                <div>{{ $t('common.shiftHandover') }}</div>
              </div>
              <div class="dropdown-item" @click="goToHelp">
                <img src="@/assets/svg/help.svg" class="iconNotSelected" alt="" />
                <img src="@/assets/svg/help1.svg" class="selectTheIcon" alt="" />
                <div>{{ $t('componentsNavbar.helpCenter') }}</div>
              </div>
              <div class="dropdown-item" @click="logout">
                <img src="@/assets/svg/exit.svg" class="iconNotSelected" alt="" />
                <img src="@/assets/svg/exit1.svg" class="selectTheIcon" alt="" />
                <div>{{ $t('componentsNavbar.logout') }}</div>
              </div>
            </div>
          </div>
          <div class="profile-picture" slot="reference" @click="toggleProfilePopover">
            <img v-if="avatar" :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar" alt />
            <img v-else src="@/assets/default-avatar.svg" class="user-avatar" alt />
            <img :src="require(`@/assets/svg/${userShifts && userShifts.code ? userShifts.code : 'morningShift'
              }.svg`)
              " class="user-avatar-img" alt />
          </div>
        </el-popover>
      </div>
    </div>

    <template v-if="isHeaderShow">
      <div id="shortcutContainer" class="shortcut" :class="{ isFixed: isFixed }">
        <div class="notice-operation" :style="showAndHideTheLeftMenu
          ? 'margin-left:20px'
          : isLeftShow
            ? 'margin-left:200px'
            : 'margin-left:75px'
          ">
          {{ hotelName }} - {{ hotelCode }}
        </div>
        <div style="display: flex; align-items: center;">
          <template v-if="isQzHotel">
            <router-link class="shortcut-item" to="/orderBox/index" target="_blank">{{ $t('navbar.orderBox') }}</router-link>
            <div class="shortcut-item" @click="openLabel('SAN_KE_BOOKING', $t('common.individualBooking'))">{{
                $t('common.individualBooking')
              }}</div>
            <div class="shortcut-item" @click="openLabel('LONG_BOOKING', $t('common.longBooking'))">{{
                $t('common.longBooking')
              }}</div>
            <div class="shortcut-item" @click="openLabel('GROUP_BOOKING', $t('navbar.groupBooking'))">{{
                $t('navbar.groupBooking')
              }}</div>

            <!-- <router-link class="shortcut-item" to="/sanKeBooking" target="_blank">{{ $t('common.individualBooking')
            }}</router-link>
            <router-link class="shortcut-item" to="/longBooking" target="_blank">{{ $t('common.longBooking')
            }}</router-link>
            <router-link class="shortcut-item" to="/groupBooking" target="_blank">{{ $t('navbar.groupBooking')
            }}</router-link> -->
            <router-link class="shortcut-item" to="/account" target="_blank">{{ $t('common.cashPayment')
            }}</router-link>
          </template>
          <div v-if="traditionalLock" class="shortcut-item" @click="cardDialog = true">{{ $t('common.doorCard') }}</div>
        </div>
      </div>

      <!--首页公告banner-->
      <!-- <Banner :is-fixed="isFixed" :shortcutDomOffetLeft="shortcutDomOffetLeft"></Banner> -->
    </template>
    <!-- 夜审信息状态 ***修改回去-->
    <component v-model="examineVisible" :is="currentNightTipComponent" :notice-night.sync="noticeNight"
      :businessDay="businessDay" :name="name" :today="today"></component>
    <!-- 开始夜审的按钮弹框 -->
    <ReadDoorCard v-if="traditionalLock" :is-show.sync="cardDialog"></ReadDoorCard>
    <SoundNotice></SoundNotice>
    <ReportPrint ref="printContent" :title="$t('componentsNavbar.reportTitle')">
      <base-table border :columns="printHeaders" :list="reportListData" :span-method="arraySpanMethod">
        <template v-slot:index="{
          scope: {
            row: { subjectName },
            $index,
          },
        }">
          {{ subjectName !== '合计' ? $index : subjectName }}
        </template>
        <template v-slot:subjectDesc="{
          scope: {
            row: { subjectName, title },
          },
        }">
          <template v-if="!title">
            {{ subjectName }}
          </template>
          <template v-else>
            <span class="group-title-text">{{ title }}</span>
            <span class="group-title-placeholder-text">{{ title }}</span>
          </template>
        </template>
        <template v-slot:income="{
          scope: {
            row: { income, subjectName, subjectCode },
          },
        }">
          <a v-if="subjectName !== '合计'" href="javascript:void(0)" class="link-href"
            @click="penetrateRoute(subjectCode)">{{ income }}</a>
          <template v-else> {{ income }}</template>
        </template>
        <template v-slot:expend="{
          scope: {
            row: { expend, subjectName, subjectCode },
          },
        }">
          <a v-if="subjectName !== '合计'" href="javascript:void(0)" class="link-href"
            @click="penetrateRoute(subjectCode, false)">{{ expend }}</a>
          <template v-else> {{ expend }}</template>
        </template>
      </base-table>
    </ReportPrint>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reportHotel, getHotelListByCode } from '@/api/user';
import { throttle } from '@/utils/index';
import { getHardwareUsedStatus } from '@/api/hardware';
import { queryHandleOverData } from '@/api/report';
import { datetimeFormat } from '@/utils/DateTimeHelper';
import store from '@/store';
import i18n from '@/utils/i18n';
import { openCommonBook } from '@/views/room-status/common-book/openCommonBook';
import { BOOKING_SCENES } from '@/views/room-status/common-book/constants';
let targetScroll = null;

export default {
  components: {
    ReadDoorCard: () => import('@/components/hardware/readDoorCard.vue'),
    NightTip: () => import('./nightCheck/night-tip'),
    NightTipGrayEnv: () => import('./nightCheck/night-tip_gray_env'),
    SoundNotice: () => import('./SoundNotice'),
    // Banner: () => import('./Banner'),
    Logo: () => import('./Sidebar/Logo'),
  },
  props: {
    isHeaderShow: {
      type: Boolean,
      default: true,
    },
    isHideSidebar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      traditionalLock: false,
      cardDialog: false,
      show: false,
      toggleHotel: false,
      currentHotel: this.hotelCode,
      examineVisible: false,
      nightCheckStart: '',
      overCheck: false,
      noticeNight: false,
      busDay: '',
      shifts: false,
      shiftsData: [],
      reportListData: [],
      listOne: [],
      listTwo: [],
      listThree: [],
      listFour: [],
      listFive: [],
      isRemind: null,
      pcDate: null,
      intervalOne: null,
      intervalOTwo: null,
      isFixed: false,
      keywords: '',
      hotelListData: [],
      hotelListLoading: true,
      shortcutDomOffetLeft: '',
      today: '',
      printHeaders: [
        {
          hidden: true,
          slot: 'index',
          title: i18n.t('common.serialNumber'),
          align: 'left',
        },
        {
          hidden: true,
          slot: 'subjectDesc',
          title: i18n.t('common.subjectDesc'),
          textOverFlow: true,
          width: 168,
          align: 'left',
        },
        {
          hidden: true,
          slot: 'income',
          title: i18n.t('componentsNavbar.headers.income'),
          width: 162,
          align: 'right',
        },
        {
          hidden: true,
          slot: 'expend',
          title: i18n.t('componentsNavbar.headers.expend'),
          width: 162,
          align: 'right',
        },
        {
          key: 'total',
          title: i18n.t('componentsNavbar.headers.total'),
          width: 162,
          align: 'right',
        },
      ],
      screenWidth: window.innerWidth,
      visible: false,
      // 消息通知数量
      systemMessage: 0,
    };
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'language',
      'authList',
      'name',
      'hotelCode',
      'hotelName',
      'roleAuthList',
      'businessDay',
      'userShifts',
      'hotelFrom',
      'isNightAuditGrayEnv',
    ]),
    backgroundImageAndlogo() {
      return this.$store.state.app.currentColorLogo
    },
    visibleMenu() {
      let limit;
      let language = store.state.app.language;
      if (language !== 'zh-CN') {
        if (this.screenWidth >= 1680) {
          limit = this.navMenuList.length; // 大屏幕显示全部
        } else if (this.screenWidth >= 1680) {
          limit = Math.max(2, this.navMenuList.length - 2); // 屏幕宽度大于等于1200px，最多显示2个
        } else if (this.screenWidth >= 1600) {
          limit = Math.max(3, this.navMenuList.length - 3); // 屏幕宽度大于等于992px，最多显示3个
        } else if (this.screenWidth >= 1455) {
          limit = Math.max(3, this.navMenuList.length - 4); // 屏幕宽度大于等于992px，最多显示3个
        } else {
          limit = Math.max(4, this.navMenuList.length - 5); // 屏幕宽度更小，最多显示4个
        }
      } else {
        if (this.screenWidth >= 1480) {
          limit = this.navMenuList.length; // 大屏幕显示全部
        } else if (this.screenWidth >= 1410) {
          limit = Math.max(3, this.navMenuList.length - 2);
        } else if (this.screenWidth >= 1340) {
          limit = Math.max(3, this.navMenuList.length - 3);
        } else if (this.screenWidth >= 1280) {
          limit = Math.max(3, this.navMenuList.length - 4);
        } else if (this.screenWidth >= 1220) {
          limit = Math.max(3, this.navMenuList.length - 5);
        } else if (this.screenWidth >= 1160) {
          limit = Math.max(3, this.navMenuList.length - 6);
        } else {
          limit = Math.max(3, this.navMenuList.length - 7);
        }
      }
      // console.log('visibleMenu limit:', limit);
      return this.navMenuList.slice(0, limit);
      // const limit = this.screenWidth >= 1440 ? this.navMenuList.length : Math.max(3, this.navMenuList.length - 3);
      // return this.navMenuList.slice(0, limit);
    },
    showAndHideTheLeftMenu() {
      return !this.isHideSidebar;
    },
    hiddenMenu() {
      let start;
      let language = store.state.app.language;
      if (language !== 'zh-CN') {
        if (this.screenWidth >= 1680) {
          start = 0; // 大屏幕没有折叠菜单
        } else if (this.screenWidth >= 1680) {
          start = Math.max(2, this.navMenuList.length - 2); //
        } else if (this.screenWidth >= 1600) {
          start = Math.max(3, this.navMenuList.length - 3); //
        } else if (this.screenWidth >= 1455) {
          start = Math.max(3, this.navMenuList.length - 4); //
        } else {
          start = Math.max(4, this.navMenuList.length - 5); // 屏幕宽度更小，隐藏更多菜单
        }
      } else {
        if (this.screenWidth >= 1480) {
          start = 0; // 大屏幕没有折叠菜单
        } else if (this.screenWidth >= 1410) {
          start = Math.max(3, this.navMenuList.length - 2);
        } else if (this.screenWidth >= 1340) {
          start = Math.max(3, this.navMenuList.length - 3);
        } else if (this.screenWidth >= 1280) {
          start = Math.max(3, this.navMenuList.length - 4);
        } else if (this.screenWidth >= 1220) {
          start = Math.max(3, this.navMenuList.length - 5);
        } else if (this.screenWidth >= 1160) {
          start = Math.max(3, this.navMenuList.length - 6);
        } else {
          start = Math.max(3, this.navMenuList.length - 7); // 屏幕宽度更小，隐藏更多菜单
        }
      }

      // console.log('hiddenMenu start:', start);
      if (start) {
        return this.navMenuList.slice(start);
      } else {
        return [];
      }
      // return this.screenWidth < 1440 ? this.navMenuList.slice(Math.max(4, this.navMenuList.length - 3)) : [];
    },
    //
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },

    // 合并列
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row && row.title) {
        if (columnIndex === 1) {
          return [1, 5];
        } else {
          return [0, 0];
        }
      } else if (row && row.subjectName === '合计') {
        if (columnIndex === 1) {
          return [0, 0];
        } else if (columnIndex === 0) {
          return [1, 2];
        } else {
          return [1, 1];
        }
      }
    },

    isCollapse() {
      return false;
    },
    currentNightTipComponent() {
      return this.isNightAuditGrayEnv ? 'NightTipGrayEnv' : 'NightTip';
    },
    doorCardEnable() {
      return this.$store.state.user.doorCardEnable;
    },
    isQzHotel() {
      return this.hotelFrom === 'qz';
    },
    isHelpShow() {
      return this.roleAuthList.find((item) => item.url.includes('/help'));
    },
    currentDomainConfig() {
      return this.$store.state.app.currentColorLogo || {};
    },
    hideAppShopEntry() {
      return this.currentDomainConfig.hideAppShopEntry;
    },
    navMenuList() {
      return this.authList
        .filter((item) => {
          const isAppShop =
            [item.path, item.url].some((url) => url && url.includes('/appShop')) ||
            (item.meta && item.meta.navMenu === 'AppShop');
          if (this.hideAppShopEntry && isAppShop) {
            return false;
          }
          return !item.hidden;
        })
        .sort((a, b) => {
          return a.urlIndex - b.urlIndex;
        });
    },
    throttleQueryHotel() {
      return throttle(this.queryHotelBykeys.bind(this), 200);
    },
    toggleClass() {
      return !this.toggleHotel ? 'el-icon-arrow-down' : 'el-icon-arrow-up';
    },
    isLeftShow() {
      return this.$store.state.app.isDisplayLeftMenu;
    },
    pageJumpStyle() {
      return this.$store.state.user.containerMode === 'oldNewLabel' ? true : false;
    },
  },
  watch: {
    '$store.state.app.systemMessage'(val) {
      this.systemMessage = val < 0 ? 0 : val > 99 ? 99 + '+' : val;
    },
    userShifts(val) {
      console.log(val, 'userShiftsuserShiftsuserShifts');
    },
    doorCardEnable(val) {
      this.traditionalLock = Boolean(val);
      this.$nextTick(() => {
        this.initNoticeSize();
      });
    },
    currentHotel(val) {
      this.$store.commit('user/SET_HOTEL_CODE', val);
    },
    keywords() {
      this.throttleQueryHotel();
    },
    toggleHotel(show) {
      if (show) {
        this.throttleQueryHotel();
      } else {
        this.keywords = '';
      }
    },
    hotelFrom(value) {
      if (value) {
        setTimeout(() => {
          this.initNoticeSize();
        }, 0);
      }
    },
    isHeaderShow(value) {
      if (value) {
        this.$nextTick(() => {
          this.initNoticeSize();
        });
      }
    },
    show(show) {
      if (show) {
        this.shiftsList();
      }
    },
  },
  created() {
    this.currentHotel = this.hotelCode;
    this.getData();
    this.checkStatus();
  },
  mounted() {
    targetScroll = document.getElementById('pageMainContent');
    window.addEventListener('scroll', this.calcScroll, true);
    this.$nextTick(() => {
      this.initNoticeSize();
    });
    window.addEventListener('resize', this.initNoticeSize, true);
  },
  methods: {
    async openLabel(label, title) {
      const sceneMap = {
        SAN_KE_BOOKING: BOOKING_SCENES.FIT,
        LONG_BOOKING: BOOKING_SCENES.LONG_STAY,
        GROUP_BOOKING: BOOKING_SCENES.TEAM,
      };
      const commonBookOpened = await openCommonBook(this, {
        bookingScene: sceneMap[label],
        title,
      });
      // 灰度酒店已经进入统一预订工作台时，不再打开旧版页面。
      if (commonBookOpened) return;
      // 非灰度酒店的完整页面模式继续使用旧版路由。
      if (this.pageJumpStyle) {
        const legacyPathMap = {
          SAN_KE_BOOKING: '/sanKeBooking',
          LONG_BOOKING: '/longBooking',
          GROUP_BOOKING: '/groupBooking',
        };
        this.$router.push(legacyPathMap[label]);
        return;
      }
      this.$modal.open({
        title: title || '',
        capabilityKey: label,
      })
    },
    jumpToTheAppStore() {
      this.$router.push({ path: '/appShop/appList' });
    },
    changeProfilePicture() {
      this.$refs.profilePicturePopover.hide();
    },
    flattenChildList(data) {
      const result = [];

      data.forEach((item) => {
        // 先将当前条目（父级）加入结果，移除 childList
        const { childList, ...parentItem } = item;
        result.push(parentItem);

        // 如果存在 childList，处理每条子数据
        if (childList && Array.isArray(childList)) {
          childList.forEach((child) => {
            // 映射子数据字段
            const childItem = {
              subjectCode: item.subjectCode || null,
              subjectName: child.name || null,
              income: child.income || null,
              expend: child.expend || null,
              total: child.total || null, // childList 中未提供 total，设为 null
              title: null, // 继承父级的 title（通常为 null）
              type: child.type || null, // 保留 type 字段
              isChild: true, // 保留 type 字段
              level: item.level,
              code: child.code,
            };
            result.push(childItem);
          });
        }
      });

      return result;
    },
    shiftsList() {
      queryHandleOverData({
        startDate: this.businessDay,
        endDate: this.businessDay,
        operatorName: this.operatorName,
        shiftsCode: this.userShifts ? this.userShifts.code : '',
      })
        .then((res) => {
          if (res.code === '0') {
            let arr = res.data.map((item, index) => {
              return {
                ...item,
                index: index,
              };
            });
            let data = this.flattenChildList(arr);
            data.splice(0, 1);
            this.shiftsData = data;
            this.reportListData = res.data;
            console.log(this.reportListData);
          } else if (res.code === '5001') {
            this.$message.warning(res.msg);
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    checkStatus() {
      getHardwareUsedStatus().then((res) => {
        this.traditionalLock = ~~res.code === 0 && res.data;
        this.$nextTick(() => {
          this.initNoticeSize();
        });
      });
    },
    initNoticeSize() {
      const shortcutDom = document.getElementById('shortcutContainer');
      this.screenWidth = window.innerWidth;
      if (shortcutDom) {
        this.shortcutDomOffetLeft = `calc(100vw - ${shortcutDom.offsetLeft - 12 + 'px'})`;
      }
    },
    goToHelp() {
      if (this.$i18n.locale === 'zh-CN') {
        window.open(`${window.origin}/help`);
      }
    },
    changeOrder() {
      this.$store.commit('user/SET_SHIFTS', {
        data: null,
        isSetLocalStorage: true,
      });
    },
    queryHotelBykeys() {
      this.hotelListLoading = true;
      getHotelListByCode({
        hotel: this.keywords,
      }).then((res) => {
        this.hotelListData = Object.freeze(res.data);
        this.hotelListLoading = false;
      });
    },
    workingDayLog() {
      window.open(`${window.origin}/operate-log`);
    },
    calcScroll() {
      if (!this.isHeaderShow) return;
      window.requestAnimationFrame(() => {
        if (targetScroll && targetScroll.scrollTop > 20) {
          if (!this.isFixed) {
            this.isFixed = true;
          }
        } else {
          if (this.isFixed) {
            this.isFixed = false;
          }
        }
      });
    },
    changeHotel(hotelCode, hotelName) {
      sessionStorage.removeItem('NOTICE_POLICY');

      this.currentHotel = hotelCode;
      this.$store.commit('user/SET_HOTEL_NAME', hotelName);
      this.$store.commit('calendar/saveScrollY', 0);
      reportHotel().then((res) => {
        this.toggleHotel = false;
        // 切换酒店需要改一下
        const nowRouter = this.$route.path;
        if (nowRouter === '/account/accountSet/Member') {
          window.location.href = `${window.origin}/account/index`;
        } else if (nowRouter === '/finance/mangement/Member') {
          window.location.href = `${window.origin}/finance/mangement`;
        } else if (nowRouter === '/appShop/appDetail') {
          window.location.href = `${window.origin}/appShop/appList`;
        } else if (nowRouter === '/appShop/createOrder') {
          window.location.href = `${window.origin}/appShop/appList`;
        } else {
          window.location.reload();
        }
        localStorage.removeItem('userShifts');
      });
    },
    async logout() {
      await this.$store.dispatch('user/logout');
    },
    async getData() {
      const { date } = await this.$store.dispatch('app/fetchCurrentTime');
      this.today = date;
      const thisTimer = Date.parse(date);
      this.pcDate = date.slice(-8);
      window.isLocalTimeIsRight = new Date().getHours() === new Date(date).getHours();
      if (!this.isNightAuditGrayEnv) {
        const isNightAuditGoing = await this.checkIsNightAuditing();
        if (isNightAuditGoing) {
          return;
        }
        const [today] = date.split(' ');
        this.isRemind = this.businessDay < today;
      }
      if (this.pcDate > '06:00' && this.pcDate <= '12:00' && this.isRemind) {
        this.noticeNight = false;
        this.examineVisible = true;
        this.intervalOne = setInterval(() => {
          this.getData();
        }, 1800000);
      } else {
        if (this.intervalOne) {
          clearInterval(this.intervalOne);
        }
      }
    },
    async beforeStart() {
      const { date } = await this.$store.dispatch('app/fetchCurrentTime');
      this.today = date;
      const isNightAuditGoing = await this.checkIsNightAuditing();
      if (isNightAuditGoing) {
        // 如果有正在执行的夜审
        return this.$message.warning($t('navbar.nightAuditWarning'));
      }
      this.noticeNight = this.businessDay !== date.slice(0, 10);
      this.examineVisible = true;
    },

    // 新增语言切换方法
    toggleLanguage(newLanguage) {
      // ;
      this.$store.commit('app/SET_LANGUAGE', newLanguage);
      this.$store.commit('user/SET_SHIFTS', {
        data: null,
        isSetLocalStorage: true,
      });
    },

    // 格式化日期只展示月和日
    datetimeFormat(date, format = 'MM-DD') {
      return datetimeFormat(date, format);
    },
    toggleNotificationDisplay() {
      this.$store.commit('app/SET_MESSAGE_NOTIFICATION_DISPLAY', true);
      this.$store.commit('app/SET_NOTIFICATION_DISPLAY');
    },
    toggleProfilePopover() {
      this.$store.commit('app/SET_MESSAGE_NOTIFICATION_DISPLAY', true);
    },
  },
};
</script>
<style lang="scss">
.router-link-exact-active .el-menu-item>span {
  background: #ffffff !important;
  color: #2c3b4e;
  font-weight: 500;
  border-radius: 12px 0 0 12px;
  width: 200px;
}

.router-link-exact-active .el-menu-item {
  min-width: 162px !important;
  background-color: #ffffff !important;
}

ul {
  list-style-type: none;
}

ul,
li,
h3,
p {
  padding: 0;
  margin: 0;
}

.baseinfo {

  // width: 400px;
  .label {
    font-size: 14px;
    color: #7b7c89;
    margin-bottom: 5px;
  }

  .el-input__inner {
    width: 336px;
    background: #fff;
    height: 40px;
    border-radius: 4px;
    border: 1px solid rgba(237, 238, 244, 1);
  }
}

.info-dialog {
  .info-body {
    padding: 20px;
    background: rgba(242, 241, 241, 1);

    li {
      margin-bottom: 20px;
    }

    li:last-child {
      margin-bottom: 0;
    }

    h3 {
      font-size: 16px;
      font-weight: 500;
      color: rgba(35, 37, 58, 1);
      line-height: 17px;
      margin-bottom: 13px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: rgba(35, 37, 58, 1);
      line-height: 20px;
    }
  }
}

.flex-div {
  display: flex;
  align-items: center;

  &:not(.right) {
    margin-bottom: 33px;
  }

  p {
    padding: 0;
    margin: 0;
    text-align: right;
    margin-right: 20px;
  }

  p:first-child {
    width: 81px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(35, 37, 58, 1);
    line-height: 17px;
  }

  p:last-child {
    font-size: 14px;
    font-weight: 500;
    color: rgba(35, 37, 58, 1);
    line-height: 14px;
  }

  .div-ul {
    li {
      padding-left: 17px;
      padding-bottom: 25px;
      font-size: 14px;
      color: rgba(35, 37, 58, 1);
      font-weight: 500;
      // border-left: 1px dashed #0068B6;
      position: relative;
    }

    li::before {
      content: '';
      width: 10px;
      height: 10px;
      border-radius: 100%;
      background: #0068b6;
      position: absolute;
      top: 4px;
      left: -5px;
    }

    li::after {
      content: '';
      width: 1px;
      height: 30px;
      border-left: 1px dashed #0068b6;
      position: absolute;
      left: 0;
      top: 14px;
    }

    li:last-child {
      padding-bottom: 0;
    }

    li:last-child::after {
      display: none;
    }
  }
}

.flex-baseline {
  align-items: baseline;
  margin-bottom: 0;
}

.hotel-search-wrapper-shifts td {
  padding: 6px 0 !important;
}

.status-dialog-navbar-el .el-dialog__header {
  display: none;
}

.status-dialog-navbar-el .el-dialog__body {
  max-height: calc(100vh - 100px) !important;
}

.shifts {
  margin-bottom: 20px;
}

.shifts>div {
  margin-top: 15px;
}

.shiftsData-button {
  width: 90%;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.right-menu {
  .order {
    border-radius: 14px;
    background: rgba(244, 245, 249, 0.1);
    margin: 0 10px;
    padding-left: 0px !important;
  }

  .hotel-select {
    width: 141px;
    margin: 0 20px;
  }

  .el-input__inner {
    height: 32px;
    background: rgba(244, 245, 249, 1);
    border-radius: 16px;
    font-weight: 400;
    font-size: 14px;
  }

  .el-input__icon {
    line-height: 32px;
    font-size: 16px;
  }

  .quick-search {
    width: 103px;
    border: none;
  }
}
</style>
<style lang="scss" scoped>
.btn-margin-right {
  margin-right: 20px;
}

.current-hotel-name {
  padding-left: 16px;
  font-size: 14px;
  color: #ffffff !important;
  font-weight: 560;
  line-height: 32px;
  height: 32px;
  background: rgba(244, 245, 249, 0.1);
  border-radius: 16px;
  padding-right: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-right: 16px;

  .hotel-name-span {
    max-width: 190px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 4px;
    display: inline-block;

    &.empty-hotel {
      max-width: 160px;
    }
  }

  .el-icon-arrow-down,
  .el-icon-arrow-up {
    opacity: 0.6;
    margin-left: 9px;
  }
}

.hotel-popver {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
}

.hotel-search-wrapper {
  padding-bottom: 30px;
  margin-top: 10px;

  /deep/ .el-input__inner {
    height: 30px !important;
    padding-left: 36px;
  }

  /deep/ .el-input__icon {
    line-height: 30px !important;
  }

  .remote-list-wrapper {
    margin-top: 10px;
    min-height: 120px;
    max-height: 190px;
    padding: 0 10px 10px 10px;
    overflow: scroll;
    @include scrollBar;
    color: #4f5161;

    .empty-hotel-tip {
      text-align: center;
      font-size: 14px;
      margin-top: 36px;
    }

    .hotel-item-wrapepr {
      white-space: nowrap;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        color: #046dbb;
      }
    }
  }

  .bottom-wrapper {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: 1px 0 20px 0 rgba(134, 150, 162, 0.1);
    border-radius: 0 0 4px 4px;
    position: absolute;
    bottom: 0;
    right: 0;
    padding-right: 10px;

    .close-btn {
      width: 50px;
      height: 26px;
      padding-bottom: 2px;
      text-align: center;
      border-radius: 4px;
      font-size: 14px;
      color: rgba(4, 109, 187, 0.9);
      background-color: #fff;
      border: 1px solid rgba(4, 109, 187, 1);
      padding: 0;
    }
  }
}

.navbar {
  height: 58px;
  background: #2c3b4e;
  // box-shadow: 0px 4px 12px 0px rgba(40, 54, 65, 0.03);
  // opacity: 0.94;
  font-weight: 500;
  min-width: 1200px;

  .navbar-inner {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
    height: 100%;

    .app-name {
      padding-left: 40px;
      padding-right: 40px;
    }

    .left-menu {
      flex: 1;
      padding-left: 12px;

      .menu-item {
        padding-right: 12px;
        padding-left: 12px;
        font-size: 16px;
        color: #bdbdc3;

        &.router-link-active {
          color: #ffffff;
          font-size: 18px;
          position: relative;

          &:after {
            content: '';
            display: block;
            width: 18px;
            height: 3px;
            background: #ffffff;
            box-shadow: 0 1px 3px 0 rgba(4, 109, 188, 0.26);
            border-radius: 1px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -7px;
          }
        }
      }

      // 两种一级菜单共用紧凑标识，固定字号避免随选中菜单放大。
      .ai-beta-badge {
        display: inline-block;
        margin-left: 3px;
        padding: 0 3px;
        border-radius: 3px;
        background: #ecf5ff;
        color: $blueText;
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        vertical-align: super;
      }

      .dropdown {
        position: relative;
        cursor: pointer;
        display: inline-block;
      }

      .dropdown-content {
        position: absolute;
        top: 38px;
        left: -30px;
        background: #2c3b4e;
        border-radius: 8px;
        display: none;
        flex-direction: column;
        width: 125px;
        /* 调整合适宽度 */
        min-height: auto;
        /* 适应内容 */
        padding: 10px 0;
        /* 添加内边距 */
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
        /* 阴影优化 */
        z-index: 99;
      }

      .dropdown-content .menu-item {
        padding: 12px 16px;
        color: #fff;
        text-align: left;
        font-size: 14px;
        transition: background 0.3s;
        text-align: center;

        &.router-link-active {
          color: #ffffff;
          font-size: 14px;
          position: relative;

          &:after {
            content: '';
            display: block;
            width: 18px;
            height: 3px;
            background: #ffffff;
            box-shadow: 0 1px 3px 0 rgba(4, 109, 188, 0.26);
            border-radius: 1px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: -1px;
          }
        }
      }

      .dropdown-content .menu-item:hover {
        background: rgba(255, 255, 255, 0.1);
        /* 增加悬停效果 */
      }

      .dropdown:hover .dropdown-content {
        display: flex;
      }

      .dropdown:hover::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 40px;
        /* 增加鼠标缓冲区 */
        background: transparent;
      }

      .el-dropdown-link {
        padding-left: 12px;
        cursor: pointer;
        color: #ffffff;
        font-size: 15px;
      }

      .el-icon-arrow-down {
        font-size: 12px;
      }
    }

    .right-menu {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #ffffff;
      white-space: nowrap;

      .shifts {
        height: 30px;
        line-height: 30px;
        padding-left: 32px !important;
        border-radius: 16px;
        margin: 0 15px;
        background: rgba(244, 245, 249, 0.1);
        position: relative;
        display: flex;
      }

      .night-check {
        width: auto;
        background: rgba(244, 245, 249, 0.1);
        border-radius: 14px;
        line-height: 32px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        margin-right: 16px;
        padding: 0 10px;
      }

      .menu-item {
        padding-left: 16px;
        padding-right: 16px;

        &.working-day {
          padding: 0 10px;
          height: 32px;
          line-height: 32px;
          background: rgba(244, 245, 249, 0.1);
          border-radius: 16px;
        }

        .menu-item-text {
          font-weight: bold;
          cursor: pointer;
        }

        .shifts {
          background: #f4f5f9;
          padding-left: 0px;
          position: relative;
        }

        .user-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: 1px solid #fff;
          vertical-align: middle;
          position: absolute;
          top: -2px;
          left: 0;
          z-index: 1;
          box-sizing: content-box;
        }

        .shift-name {
          display: inline-block;
          padding-left: 6px;
        }

        .user-name {
          color: #ffffff;
          padding-left: 6px;
          max-width: 60px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display: inline-block;

          &.notQz {
            max-width: initial;
          }
        }

        .nav-icon-wrapper {
          width: 32px;
          height: 32px;
          background-color: rgba(244, 245, 249, 0.1);
          background-size: 19px 19px;
          background-position: center center;
          background-repeat: no-repeat;
          border-radius: 50%;
          cursor: pointer;

          &.notice {
            background-image: url('../../assets/notice.png');
          }

          &.exit {
            background-image: url('../../assets/icon-exit.png');
          }

          &.help {
            background-image: url('../../assets/help.png');
          }
        }

        &.help-center {
          padding-right: 0;
        }

        &.logout {
          cursor: pointer;
          padding-right: 20px;
          padding-left: 15px;
        }
      }

      .language-select {
        width: 70px;
        margin-right: 16px;

        ::v-deep .el-input__inner {
          height: 32px;
          background: rgba(244, 245, 249, 0.1);
          border: none;
          color: white;
          padding-right: 30px;

          &::placeholder {
            color: rgba(255, 255, 255, 0.8);
          }
        }

        ::v-deep .el-input__suffix {
          top: 3px;

          .el-icon-arrow-up {
            color: white;
          }
        }
      }

      // 下拉框样式
      .language-select-popper {
        min-width: 100px !important;

        .el-select-dropdown__item {
          padding: 0 16px;
          height: 36px;
          line-height: 36px;
          color: #606266;

          &.selected {
            color: #046dbb;
          }

          &:hover {
            background-color: #f5f7fa;
          }
        }
      }
    }

    .profile-picture {
      width: 32px;
      height: 32px;
      margin-right: 16px;
      position: relative;
      display: flex;
      justify-content: center;
      cursor: pointer;

      .user-avatar {
        width: 30px;
        height: 30px;
        border-radius: 30px;
      }

      .user-avatar-img {
        width: 32px;
        position: absolute;
        top: 18px;
      }

      .profile-picture-shift-name {
        width: 35px;
        height: 12px;
        background-color: #ffc771;
        border-radius: 6px;
        position: absolute;
        top: 18px;
        box-sizing: border-box;
        padding: 0 3px;
        text-align: right;
        font-size: 9px;
        line-height: 12px;
        color: #bf6b11;
      }

      .notification-count {
        position: absolute;
        top: -4px;
        left: 20px;
        min-width: 16px;
        height: 16px;
        line-height: 16px;
        background-color: #ff4d4f;
        color: #fff;
        font-size: 10px;
        text-align: center;
        border-radius: 8px;
        padding: 0 4px;
        box-sizing: border-box;
      }
    }
  }
}

.notice-operation {
  flex: 1;
  display: flex;
  align-items: center;
  padding-top: 8px;
  box-sizing: border-box;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: bold;
  font-size: 18px;
  color: #23253a;
  position: relative;
  top: -3px;
  overflow: hidden;
  /* 内容超出隐藏 */
  text-overflow: ellipsis;
  /* 显示省略号 */
  white-space: nowrap;
  /* 不换行 */
  min-width: 0;
  /* 🔥关键：允许内容被压缩 */
  display: inline-block;
}

.shortcut {
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: space-between;
  position: fixed;
  top: 64px;
  z-index: 4;
  padding-right: 30px;
  box-sizing: border-box;

  &.isFixed {
    top: 64px;
    // margin-top: -29px;

    .shortcut-item {
      background-color: #edeef4;
      color: #23253a;
    }

    :hover {
      color: #046dbb;
    }

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 43px;
      background-color: #fff;
      position: fixed;
      top: 58px;
      right: 0;
      z-index: -1;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
    }
  }

  .shortcut-item {
    cursor: pointer;
    width: auto;
    height: 32px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    font-size: 12px;
    color: #23253a;
    margin-right: 12px;
    font-weight: bold;
    padding: 0 10px;

    &:hover {
      color: #1F6AFF;
      background-color: #E0EAFF;
    }
  }
}

/deep/ .dropdown-style {
  -webkit-user-select: none;
  /* Safari/Chrome */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE/Edge */
  user-select: none;

  /* 标准属性 */
  .pop-up-box-item {
    display: flex;
    margin-bottom: 16px;

    .pull-down-style {
      width: 35px;
      height: 32px;
      margin-right: 18px;
      position: relative;
      display: flex;
      justify-content: center;
      cursor: pointer;

      .user-avatar {
        width: 30px;
        height: 30px;
        background-color: #046dbb;
        border-radius: 30px;
      }

      .user-avatar-img {
        width: 32px;
        height: 13px;
        position: absolute;
        top: 18px;
      }

      .profile-picture-shift-name {
        width: 35px;
        height: 12px;
        background-color: #ffc771;
        border-radius: 6px;
        position: absolute;
        top: 18px;
        box-sizing: border-box;
        padding: 0 3px;
        text-align: right;
        font-size: 9px;
        line-height: 12px;
        color: #bf6b11;
      }
    }

    .user-name-pop {
      margin-top: -1px;
      font-weight: bold;
      font-size: 14px;
      color: #393a4d;
    }

    .profile-picture-shift-name-pop {
      font-weight: 400;
      font-size: 10px;
      color: #999999;
    }
  }

  .dropdown-item {
    padding: 12px 12px;
    box-sizing: border-box;
    color: #999999;
    cursor: pointer;
    display: flex;

    div {
      margin-left: 16px;
    }

    .iconNotSelected {
      display: none;
    }

    .selectTheIcon {
      display: inline-block;
    }
  }

  .dropdown-item:hover {
    background: linear-gradient(270deg, rgba(238, 241, 255, 0.57) 0%, #eef1ff 100%);
    color: #393a4d;

    .iconNotSelected {
      display: inline-block;
    }

    .selectTheIcon {
      display: none;
    }
  }
}
</style>
